import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { resolveRoute } from "@/lib/resolveRoute";

export default function Breadcrumbs({ lang }) {
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const segments = pathname.split("/").filter(Boolean);

  if (segments.length <= 1) {
    return null;
  }

  return (
    <nav className="tgwe-breadcrumbs" aria-label="Breadcrumb">
      <Link to={resolveRoute(lang, "home")}>{t("site.name")}</Link>
      {segments.slice(1).map((segment, index) => (
        <span key={`${segment}-${index}`} aria-current={index === segments.length - 2 ? "page" : undefined}>
          {segment.replaceAll("-", " ")}
        </span>
      ))}
    </nav>
  );
}
